var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-header-index-wide" },
    [
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            {
              style: { marginBottom: "24px" },
              attrs: { justify: "center", sm: 12, md: 12, xl: 12 }
            },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "500px" },
                  attrs: { title: _vm.language["home.todo"] }
                },
                [
                  _c("a-table", {
                    attrs: {
                      size: "middle",
                      bordered: "",
                      columns: this.columns,
                      "data-source": this.sourceBacklog
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "details",
                        fn: function(text, record) {
                          return _c("span", {}, [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.showCheckTableInfo(record)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.language["show.detail"]))]
                            )
                          ])
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { marginBottom: "24px" },
              attrs: { justify: "center", sm: 12, md: 12, xl: 12 }
            },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "500px" },
                  attrs: {
                    title: _vm.stateTitle,
                    "body-style": { "text-align": "center" }
                  }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { slot: "extra" },
                      on: { click: _vm.showStateTableInfo },
                      slot: "extra"
                    },
                    [_vm._v(_vm._s(_vm.language["show.detail"]))]
                  ),
                  _c("pie", {
                    staticStyle: { "margin-right": "80px" },
                    attrs: { dataSource: this.sourceDataState }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            {
              style: { marginBottom: "24px" },
              attrs: { justify: "center", sm: 12, md: 12, xl: 12 }
            },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "500px" },
                  attrs: { title: _vm.levelTitle }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { slot: "extra" },
                      on: { click: _vm.showLevelTableInfo },
                      slot: "extra"
                    },
                    [_vm._v(_vm._s(_vm.language["show.detail"]))]
                  ),
                  _c("pie", {
                    staticStyle: { "margin-right": "160px" },
                    attrs: { dataSource: this.sourceDataLevel }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { marginBottom: "24px" },
              attrs: { justify: "center", sm: 12, md: 12, xl: 12 }
            },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "500px" },
                  attrs: { title: _vm.typeTitle }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { slot: "extra" },
                      on: { click: _vm.showTypeTableInfo },
                      slot: "extra"
                    },
                    [_vm._v(_vm._s(_vm.language["show.detail"]))]
                  ),
                  _c("pie", {
                    staticStyle: { "margin-right": "160px" },
                    attrs: { dataSource: this.sourceDataType }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }